/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unreachable */
import BreadCrumb from 'Components/Common/BreadCrumb';
import TableContainer from 'Components/Common/TableContainer';
import { AREAS, REQUESTS_TABLE_SCHEMA, USERS_SCHEMA } from 'Components/Common/TableSchemas/TableSchemas';
import withRouter from 'Components/Common/withRouter';
import React, { useEffect, useRef, useState } from 'react';
import { Button, Card, CardBody, CardFooter, Col, Container, Row } from 'reactstrap';
import { useAsyncDebounce } from 'react-table';
import DeleteModal from 'Components/Common/DeleteModal';
import { AuthUser, filterValidParams, generateInitialValues, generateValidationSchema, trimValues } from 'Components/Common/Util';
import * as url from '../../../src/helpers/url_helper';
import {
    ADD_AREAS,
    ADD_MINES,
    NEW_USER_REQUESTS_FORM_SCHEMA,
    NEW_USER_REQUESTS_FORM_SCHEMA_CHECKBOX,
    NEW_USER_REQUESTS_FORM_SCHEMA_REJECTION_COMMENT
} from 'Components/Common/FormSchemas/FormSchema';
import SelectComponent from 'Components/DynamicComponents/SelectComponent';
import InputComponent from 'Components/DynamicComponents/InputComponent';
import Checkbox from 'Components/DynamicComponents/Checkbox';
import InputGroupComponent from 'Components/DynamicComponents/InputGroupComponent';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useLocation } from 'react-router-dom';
import DatePicker from 'Components/DynamicComponents/DatePicker';
import { toast } from 'react-toastify';
import toastMessages from 'Components/Common/messages/toastMessages';
import Loader from 'Components/Common/Loader';
import CommonModal from 'Components/Common/CommonModal';
import { AREAS_DROPDOWN, MINES_DROPDOWN } from 'fakeResponses/fakeResponse';

const ViewUserRequests = (props: any) => {
    const location = useLocation();
    const { state } = location;
    const api = props.router.apiClient;
    const [loading, setLoading] = useState<boolean>(false);
    const [reqUser, setReqUser] = useState<any>(undefined);
    const [newUserRequestFormSchema, setNewUserRequestFormSchema] = useState<any>(NEW_USER_REQUESTS_FORM_SCHEMA);
    const [newUserRequestFormSchemaCheckBoxes, setNewUserRequestFormSchemaCheckBoxes] = useState<any>(
        NEW_USER_REQUESTS_FORM_SCHEMA_CHECKBOX
    );
    const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
    const [modalLoader, setModalLoader] = useState<boolean>(false);
    const [newUserRequestsFormSchemaRejectionComment, setNewUserRequestsFormSchemaRejectionComment] = useState<any>(
        NEW_USER_REQUESTS_FORM_SCHEMA_REJECTION_COMMENT
    );
    const isManualChange = useRef(false);

    const generateFetchValues = (formData: any[], rowData: any) => {
        const initialValues: any = {};
        formData?.forEach((field) => {
            if (field.inputType === 'input') {
                initialValues[field?.value] = rowData?.[field?.value] || '';
            } else if (field.inputType === 'dropdown') {
                initialValues[field?.value] = field.options?.find((opt: any) => opt.value === rowData?.[field?.value]);
            } else if (field.inputType === 'dateRange') {
                initialValues[field?.value] = rowData?.[field?.value] || '';
            }
        });
        return initialValues;
    };

    const formValidation: any = useFormik({
        enableReinitialize: true,
        initialValues: generateFetchValues(newUserRequestFormSchema, location?.state?.data),
        validationSchema: generateValidationSchema(newUserRequestFormSchema, Yup),
        validate: (values: any) => trimValues(values, newUserRequestFormSchema),
        onSubmit: (values: any) => {
            //
        }
    });
    const formValidationReject: any = useFormik({
        enableReinitialize: true,
        initialValues: generateFetchValues(newUserRequestsFormSchemaRejectionComment, ''),
        validationSchema: generateValidationSchema(newUserRequestsFormSchemaRejectionComment, Yup),
        validate: (values: any) => trimValues(values, newUserRequestsFormSchemaRejectionComment),
        onSubmit: (values: any) => {
            //
        }
    });
    const validateCheckBoxes = (schema: any) => {};
    const formValidationCheckbox: any = useFormik({
        enableReinitialize: true,
        initialValues: {
            privileges: false,
            VIEW_CLIENT_AREAS: false,
            MAP_VIEW: false,
            REPORTS: false,
            DOWNLOADS: false,
            LAYERS: false,
            SATELLITE: false,
            MEASURING_TOOL: false,
            DEFAULT_POINTER: false,
            LEGENDS: false,
            DRAW_TOOL: false,
            DRAWN_LAYERS: false,
            IDENTIFIER: false,
            EXPORT: false,
            PRINT: false,
            ROTATE: false,
            COMPARISION: false,
            BUFFER_TOOL: false,
            SITE_UPDATES: false,
            '3D_SCENE': false
        },
        validationSchema: generateValidationSchema(newUserRequestFormSchemaCheckBoxes, Yup),
        validate: (values: any) => trimValues(values, newUserRequestFormSchemaCheckBoxes),
        onSubmit: (values: any) => {
            //
        }
    });
    useEffect(() => {
        if (!isManualChange.current) {
            if (formValidationCheckbox.values?.privileges) {
                Object.keys(formValidationCheckbox.values).forEach((key) => (formValidationCheckbox.values[key] = true));
            } else {
                Object.keys(formValidationCheckbox.values).forEach((key) => (formValidationCheckbox.values[key] = false));
            }
        }
        isManualChange.current = false;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formValidationCheckbox.values?.privileges]);

    useEffect(() => {
        const allTrueExceptPrivileges = Object.entries(formValidationCheckbox.values).every(
            ([key, value]) => key === 'privileges' || value === true
        );
        const allTrue = Object.entries(formValidationCheckbox.values).every(([key, value]) => value === true);

        if (allTrue) {
            isManualChange.current = true;
        }
        if (allTrue === false && allTrueExceptPrivileges === true) {
            Object.keys(formValidationCheckbox.values).forEach((key) => (formValidationCheckbox.values[key] = false));
        }
        formValidationCheckbox.setFieldValue('privileges', allTrue);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formValidationCheckbox.values]);

    useEffect(() => {
        getRequestUserData();
        getAreas();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state]);
    useEffect(() => {
        const areas = formValidation.values?.areas;
        // if (!Array.isArray(areas) || areas.length === 0) return;
        const areaRefs: any = [];
        formValidation?.values?.areas?.forEach((area: any) => {
            areaRefs.push(area?.areaRef);
        });
        getMines(areaRefs);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formValidation.values?.areas]);
    const getRequestUserData = () => {
        const filterPayload = {
            reqRef: state?.data?.reqRef
        };

        const filters = filterValidParams(filterPayload);

        const payLoad = {
            params: {
                search: JSON.stringify(filters)
            }
        };
        api.get(url?.GET_REQUESTS, payLoad, false, false)
            .then((resp: any) => {
                if (resp?.status?.toLowerCase() === 'success' && resp?.data) {
                    setReqUser(resp?.data?.data?.[0]);
                    // toast.success(toastMessages?.mineUpdate);
                }
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
                // props?.router?.navigate('/area');
                // props?.router?.navigate('/allarea/mines', {
                //     state: {
                //         data: state?.areaDetails
                //     }
                // });
            });
    };
    const getAreas = () => {
        const payLoad = {
            search: JSON.stringify({ active: 'true' })
        };
        setLoading(true);
        api.get(url.GET_AREA, { params: payLoad })
            .then((res: any) => {
                if (res?.status?.toLowerCase() === 'success') {
                    const areaOptions = res?.data?.data
                        .filter((item: any) => item?.mineCount > 0)
                        ?.map((item: any) => ({
                            ...item,
                            label: item?.areaName,
                            value: item?.areaRef
                        }));

                    const updatedSchema = newUserRequestFormSchema.map((schema: any) => {
                        if (schema?.value === 'areas') {
                            return {
                                ...schema,
                                options: areaOptions
                            };
                        }
                        return schema;
                    });
                    setNewUserRequestFormSchema(updatedSchema);

                    setLoading(false);
                } else {
                    setLoading(false);
                }
            })
            .catch((err: any) => {
                setLoading(false);
            });
    };
    const getMines = (areaRefs: any, roleDetails?: any) => {
        const payLoad = {
            search: JSON.stringify({ areaId: areaRefs?.join(',') })
        };
        setLoading(true);
        api.get(url.GET_MINES, { params: payLoad })
            .then((res: any) => {
                if (res?.status?.toLowerCase() === 'success') {
                    const mineOptions = res?.data?.data.map((item: any) => ({
                        ...item,
                        label: item?.mineName,
                        value: item?.mineRef
                    }));

                    // if (roleDetails !== undefined && Object.keys(roleDetails)?.length > 0) {
                    //     addRoleValidation?.setFieldValue(
                    //         'mines',
                    //         roleDetails?.minesList !== undefined && roleDetails?.minesList?.length > 0
                    //             ? roleDetails?.minesList?.map((mine: any) => ({ value: mine?.value, label: mine?.label }))
                    //             : undefined
                    //     );
                    // }
                    // Inject mine options into the form schema
                    const updatedSchema = newUserRequestFormSchema.map((schema: any) => {
                        if (schema?.value === 'mines') {
                            return {
                                ...schema,
                                isVisible: true,
                                mandatory: false,
                                options: [...mineOptions]
                            };
                        }
                        return schema;
                    });

                    setNewUserRequestFormSchema(updatedSchema);
                    setLoading(false);
                } else {
                    setLoading(false);
                }
            })
            .catch(() => setLoading(false));
    };
    const handleChange = (e: any, field: any) => {};

    const dynamicData = (field: any): JSX.Element | any => {
        switch (field.inputType) {
            case 'input':
                return (
                    <div className={'my-3 px-3'}>
                        <InputComponent field={field} mode={''} validation={formValidation} labelBold={true}></InputComponent>
                    </div>
                );
            case 'dropdown':
                return (
                    <div className={'my-3 '}>
                        <SelectComponent
                            field={field}
                            mode={'add'}
                            validation={formValidation}
                            onChange={(e) => handleChange(e, field)}
                        ></SelectComponent>
                    </div>
                );
            case 'dateRange':
                return (
                    <div className="my-3 px-4">
                        <DatePicker
                            field={field}
                            mode={'add'}
                            validation={formValidation}
                            pickerMode={field.pickerMode}
                            // pickerMinDate={field.pickerMinDate}
                            // pickerMaxDate={field.pickerMaxDate}
                        />
                    </div>
                );
            case 'checkbox':
                return (
                    <div className="my-0">
                        <Checkbox
                            field={field}
                            validation={formValidationCheckbox}
                            mode=""
                            // onChange={handleCheckboxChange}
                            // checked={formValidationCheckbox?.values?.[field.value]}
                            checked={formValidationCheckbox?.values?.[field.value]}
                        />
                    </div>
                );
            default:
                break;
        }
    };
    const dynamicDataRejection = (field: any): JSX.Element | any => {
        switch (field.inputType) {
            case 'input':
                return (
                    <div className={'my-3 px-3'}>
                        <InputComponent field={field} mode={''} validation={formValidationReject}></InputComponent>
                    </div>
                );

            default:
                break;
        }
    };

    const viewAreasBody = () => {
        return (
            <React.Fragment>
                {/* <button onClick={clicked}>click</button> */}
                <Row>
                    {newUserRequestsFormSchemaRejectionComment?.length > 0 &&
                        newUserRequestsFormSchemaRejectionComment.map((field: any, index: number) => {
                            return (
                                <Col key={index} lg={field.lg1}>
                                    {dynamicDataRejection(field)}
                                </Col>
                            );
                        })}
                </Row>
            </React.Fragment>
        );
    };
    const rejectUser = () => {
        setIsOpenModal(!isOpenModal);
        formValidationReject.resetForm();
    };

    const submitUser = () => {
        // const roles = [
        //     {
        //         name: 'USER',
        //         privileges: Object.keys(formValidationCheckbox?.values).filter((key) => formValidationCheckbox?.values[key] === true)
        //     }
        // ];
        const responseBody = {
            reqRef: reqUser?.reqRef,
            status: 'APPROVE',
            createdAt: reqUser?.createdAt,
            empId: reqUser?.empId,
            firstName: reqUser?.firstName,
            lastName: reqUser?.lastName,
            email: reqUser?.email,
            phoneNumber: reqUser?.phoneNumber,
            department: reqUser?.department,
            address: reqUser?.address,
            profileImage: reqUser?.profileImage,
            userProfile: {
                roles: [
                    {
                        role: 'USER',
                        roleId: 'R4096',
                        privileges: Object.keys(formValidationCheckbox?.values).filter(
                            (key) => formValidationCheckbox?.values[key] === true
                        ),
                        areaIds: formValidation.values?.areas.map((area: any) => {
                            const { areaRef, areaName, value, label } = area;

                            const filteredMines =
                                formValidation.values?.mines !== undefined
                                    ? formValidation.values?.mines
                                          ?.filter((mine: any) => mine?.areaId?.toLowerCase() === areaRef?.toLowerCase())
                                          .map((mine: any) => ({
                                              mineRef: mine?.mineRef,
                                              mineName: mine?.mineName,
                                              areaId: mine?.areaId
                                          }))
                                    : [];

                            return {
                                areaRef: areaRef ?? value,
                                areaName: areaName ?? label,
                                mines: filteredMines
                            };
                        })
                    }
                ]
            }
        };
        setLoading(true);
        api.create(url?.REQUEST_USER_APPROVE, responseBody, false, false)
            .then((resp: any) => {
                if (resp?.status?.toLowerCase() === 'success' && resp?.data) {
                    // toast.success(resp?.message);
                    props?.router?.navigate('/user-management-new-request');
                    toast.success(toastMessages?.newUserRequestApproved);
                }
                setLoading(false);
            })
            .catch((err: any) => {
                setLoading(false);
                toast.error(err?.message);
            });
    };
    const rejectUserWithComment = () => {
        setLoading(true);
        const responseBody = {
            reqRef: reqUser?.reqRef,
            status: 'REJECT',
            comment: formValidationReject.values?.comments
        };
        if (state?.data?.profileImage) {
            handleDeleteFile(undefined, { preview: state?.data?.profileImage });
        }
        api.create(url?.REQUEST_USER_APPROVE, responseBody, false, false)
            .then((resp: any) => {
                if (resp?.status?.toLowerCase() === 'success' && resp?.data) {
                    // toast.success(resp?.message);
                    props?.router?.navigate('/user-management-new-request');
                    toast.success(toastMessages?.newUserRequestRejected);
                }
                setLoading(false);
            })
            .catch((err: any) => {
                setLoading(false);
                // props?.router?.navigate('/area');
                toast.error(err?.message);
            });
    };
    const handleDeleteFile = (fieldName: any, file: any) => {
        const filepath = file.preview;
        setLoading(true);
        api.deleteFile(`${url.DELETE_DOCUMENTS}/${filepath}`)
            .then((resp: any) => {
                if (resp?.status?.toLowerCase() === 'success') {
                    setLoading(false);
                } else {
                    setLoading(false);
                }
            })
            .catch((e: any) => setLoading(false))
            .finally(() => {
                setLoading(false);
            });
    };
    return (
        <React.Fragment>
            <div className="page-content">
                {loading && <Loader />}
                <BreadCrumb
                    subTitle={[
                        { label: 'User Management', link: '/user-management' },
                        { label: 'New Request', link: '/user-management-new-request' },
                        { label: 'View Request', link: '/user-management-new-request' }
                    ]}
                />
                <Container fluid>
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardBody className="p-4">
                                    <Row>
                                        <Col>
                                            <div className="mb-4 font-weight-600 font-size-18">User Details</div>
                                            {/* <button onClick={clicked}>click</button> */}
                                        </Col>
                                    </Row>

                                    <Row className="gx-5 gy-3">
                                        <Col md={6} lg={4}>
                                            <div className="font-size-14 font-weight-500 line-height-24 text-gray-50 my-2">Emp ID</div>
                                            <div className="font-size-16 font-weight-500 line-height-24">
                                                {reqUser?.empId || 'Not Available'}
                                            </div>
                                        </Col>
                                        <Col md={6} lg={4}>
                                            <div className="font-size-14 font-weight-500 line-height-24 text-gray-50 my-2">User Name</div>
                                            <div className="font-size-16 font-weight-500 line-height-24">
                                                {reqUser?.firstName + ' ' + reqUser?.lastName || 'Not Available'}
                                            </div>
                                        </Col>
                                        <Col md={6} lg={4}>
                                            <div className="font-size-14 font-weight-500 line-height-24 text-gray-50 my-2">Email ID</div>
                                            <div className="font-size-16 font-weight-500 line-height-24">
                                                {reqUser?.email || 'Not Available'}
                                            </div>
                                        </Col>
                                        <Col md={6} lg={4}>
                                            <div className="font-size-14 font-weight-500 line-height-24 text-gray-50 my-2">
                                                Contact Number
                                            </div>
                                            <div className="font-size-16 font-weight-500 line-height-24">
                                                {reqUser?.phoneNumber?.code + ' ' + reqUser?.phoneNumber?.value || 'Not Available'}
                                            </div>
                                        </Col>
                                        <Col md={6} lg={4}>
                                            <div className="font-size-14 font-weight-500 line-height-24 text-gray-50 my-2">Address</div>
                                            <div className="font-size-16 font-weight-500 line-height-24">
                                                {reqUser?.address || 'Not Available'}
                                            </div>
                                        </Col>
                                        <Col md={6} lg={4}>
                                            <div className="font-size-14 font-weight-500 line-height-24 text-gray-50 my-2">Role</div>
                                            <div className="font-size-16 font-weight-500 line-height-24">User</div>
                                        </Col>
                                        {/* <Col md={6} lg={4}>
                                        <div className="font-size-14 font-weight-500 line-height-24 text-gray-50 my-2">Sub Module</div>
                                        <div className="font-size-16 font-weight-500 line-height-24">Mining Land</div>
                                    </Col> */}
                                        <Col md={6} lg={4}>
                                            <div className="font-size-14 font-weight-500 line-height-24 text-gray-50 my-2">Created By</div>
                                            <div className="font-size-16 font-weight-500 line-height-24">
                                                {reqUser?.createdBy || 'Not Available'}
                                            </div>
                                        </Col>
                                        <Col md={6} lg={4}>
                                            <div className="font-size-14 font-weight-500 line-height-24 text-gray-50 my-2">
                                                Created Date
                                            </div>
                                            <div className="font-size-16 font-weight-500 line-height-24">
                                                {reqUser?.createdAt || 'Not Available'}
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        {state?.data?.status === 'PENDING' &&
                                            newUserRequestFormSchema?.length > 0 &&
                                            newUserRequestFormSchema.map((field: any, index: number) => {
                                                if (!field.isVisible) return null;
                                                return (
                                                    <React.Fragment key={index}>
                                                        <Col lg={field.lg1}>{dynamicData(field)}</Col>
                                                    </React.Fragment>
                                                );
                                            })}
                                    </Row>
                                    <Row>
                                        {/* <div className="font-size-16 font-weight-500">Privilege Details</div> */}
                                        {state?.data?.status === 'PENDING' && (
                                            <div>
                                                <Checkbox
                                                    field={newUserRequestFormSchemaCheckBoxes?.[0]}
                                                    validation={formValidationCheckbox}
                                                    mode=""
                                                    // onChange={handleCheckBox}
                                                    checked={
                                                        formValidationCheckbox?.values?.[newUserRequestFormSchemaCheckBoxes?.[0].value]
                                                    }
                                                    // checked={true}
                                                />
                                            </div>
                                        )}
                                        {/* <div className=" thin-label font-size-16">Privilege Details</div> */}
                                        {state?.data?.status === 'PENDING' &&
                                            newUserRequestFormSchemaCheckBoxes?.length > 0 &&
                                            newUserRequestFormSchemaCheckBoxes?.[0]?.options.map((field: any, index: number) => {
                                                // if (!field.isVisible) return null;
                                                return (
                                                    <React.Fragment key={index}>
                                                        <Col lg={field.lg1}>{dynamicData(field)}</Col>
                                                    </React.Fragment>
                                                );
                                            })}
                                    </Row>
                                    {/* <Row className="gx-5 gy-3 mb-5">
                                    <div className="font-size-16 font-weight-500 line-height-24">Privileges Details</div>
                                    {privileges?.map((privilege: any, index: number) => (
                                        <Col key={index} md={6} lg={4}>
                                            <Checkbox field={privilege} validation={formValidation} mode="" checked={privilege.checked} />
                                        </Col>
                                    ))}
                                </Row> */}
                                </CardBody>
                                {state?.data?.status === 'PENDING' && (
                                    <CardFooter>
                                        <Row>
                                            <div className="d-flex gap-3 justify-content-end mb-2">
                                                <Button
                                                    outline
                                                    className="w-sm btn-outline-success border-2 br-8 font-weight-600 font-size-16 px-5"
                                                    color=""
                                                    onClick={rejectUser}
                                                    data-bs-dismiss="modal"
                                                >
                                                    {'Reject'}
                                                </Button>
                                                <button
                                                    type="submit"
                                                    className="btn w-sm btn-primary br-8 text-secondary font-weight-600 font-size-16 px-5"
                                                    disabled={
                                                        loading ||
                                                        !formValidation.dirty ||
                                                        !formValidation.isValid ||
                                                        !Object.values(formValidationCheckbox.values).some((value) => value === true)
                                                    }
                                                    onClick={submitUser}
                                                >
                                                    {'Approve'}
                                                </button>
                                            </div>
                                        </Row>
                                    </CardFooter>
                                )}
                            </Card>
                        </Col>
                    </Row>
                    <CommonModal
                        size={'lg'}
                        isHeader={true}
                        show={isOpenModal}
                        handleModalBody={viewAreasBody}
                        onCloseClick={() => {
                            setIsOpenModal(!isOpenModal);
                        }}
                        headerClass={''}
                        modalheader={'Rejection Comment'}
                        hideSaveButton={false}
                        saveText={'Submit'}
                        hideCancelButton={false}
                        cancelText={'Cancel'}
                        backgroundColor={true}
                        headerColor={'black'}
                        handleClick={rejectUserWithComment}
                        disabled={loading || !formValidationReject.dirty || !formValidationReject.isValid}
                        // cancelText={'Cancel'}
                        // saveText={mode === 'add' || mode === '' ? 'Save' : 'Update'}
                        // handleClick={validation.handleSubmit}
                    />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default withRouter(ViewUserRequests);
